import React, { useEffect, useState } from "react";
import { State, City } from "country-state-city";
import { singleteam } from "redux-store/care-team/care-team.selector";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  addNewteam,
  getSingleteam,
  updateSingleteam,
} from "redux-store/care-team/care-team.slice";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  teamActivityInProcess,
  successMessage,
  teamError,
} from "redux-store/care-team/care-team.selector";
import {
  errorClean,
  messageClean,
} from "redux-store/care-team/care-team.slice";
import {
  validateAddress,
  validateText,
  validateCity,
  validateEmail,
  validatePhone,
  validateZipCode,
  validateName,
} from "components/utils/regexValidation";

export default function AddCareTeamComp() {
  const [showFullText, setShowFullText] = useState(false);
  // const [checked, setChecked] = useState(false);
  const [states, setStates] = useState<any | null>([]);
  const [cities, setCities] = useState<any | null>([]);

  const [countryCode, setCountryCode] = useState("US");
  const [stateCode, setStateCode] = useState("");

  const team = useSelector(singleteam);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector(teamActivityInProcess);
  const teamMessage = useSelector(successMessage);
  const errorMessage = useSelector(teamError);
  const teamId = params.teamId;
  const location = useLocation();

  const [formData, setFormData] = useState({
    _id: "",
    hospitalName: "",
    email: "",
    veterinarianName: "",
    phone: "",
    zipCode: "",
    apartment: "",
    state: "",
    city: "",
    address: "",
  });

  useEffect(() => {
    if (window.location.pathname !== "/user/care-team/add-care-team/add") {
      if (
        window.location.pathname !==
        "/user/care-team/add-care-team/add/activate"
      ) {
        team &&
          setFormData({
            _id: team?._id,
            hospitalName: team?.hospitalName,
            email: team?.email,
            veterinarianName: team?.veterinarianName,
            phone: team?.phone,
            zipCode: team?.zipCode,
            apartment: team?.apartment,
            state: team?.state,
            city: team?.city,
            address: team?.address,
          });
      }
    }
  }, [team]);
  const [errMessages, setMessages] = useState({
    emptyMessage: "",
    hospitalName: "",
    vetName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
  });
  const data = [
    {
      name: "hospitalName",
      label: "Veterinary Hospital Name",
      type: "text",
      placeholder: "Enter Veterinary Hospital Name",
    },
    {
      name: "veterinarianName",
      label: "Veterinarian Name",
      type: "text",
      placeholder: "Enter Veterinarian Name",
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Enter Veterinarian / Hospital Email",
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "number",
      placeholder: "Enter Veterinarian / Hospital Phone Number",
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      placeholder: "Enter Veterinarian / Hospital Address",
    },
    {
      name: "apartment",
      label: "Apartment, Suite, Building",
      type: "text",
      placeholder: "Enter Address Line 2",
    },
    { name: "city", label: "City", type: "text", placeholder: "Enter City" },
    {
      name: "zipCode",
      label: "Zip Code",
      type: "number",
      placeholder: "Enter Zip Code",
    },
  ];

  const cityData = (stateCode: string) => {
    let newCities = City.getCitiesOfState(countryCode, stateCode).map(
      (city) => ({
        name: city.name,
      })
    );
    setCities(newCities);
  };
  const stateData = () => {
    let newStates = State.getStatesOfCountry(countryCode).map((state) => ({
      name: state.name,
      code: state.isoCode,
    }));
    setStates(newStates);
  };

  const onChange = (e: any) => {
    const value = e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  const stateChangeHandler = (name: any) => {
    setFormData({ ...formData, state: name });
  };

  const handleAddClick = () => {
    dispatch(errorClean());
    if (teamMessage !== "") {
      dispatch(messageClean());
    }
    if (formData.email !== "") {
      if (formData.hospitalName !== "") {
        if (!validateText(formData.hospitalName)) {
          setMessages({
            ...errMessages,
            hospitalName: "Hospital should be text",
            emptyMessage: "",
            city: "",
            zipCode: "",
            vetName: "",
            address: "",
            state: "",
            phone: "",
            email: "",
          });
          return;
        }
      }

      if (formData.email !== "") {
        if (!validateEmail(formData.email)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "",
            zipCode: "",
            vetName: "",
            address: "",
            state: "",
            phone: "",
            email: "Email Not Valid",
          });
          return;
        }
      }

      if (formData.phone !== "") {
        if (!validatePhone(formData.phone)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "",
            zipCode: "",
            vetName: "",
            address: "",
            state: "",
            phone: "Invalid Phone Number",
            email: "",
          });
          return;
        }
      }
      if (formData.address !== "") {
        if (!validateAddress(formData.address)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "",
            zipCode: "",
            vetName: "",
            address: "Invalid Address",
            state: "",
            phone: "",
            email: "",
          });
          return;
        }
      }
      if (formData.city !== "") {
        if (!validateCity(formData.city)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "Invalid City",
            zipCode: "",
            vetName: "",
            address: "",
            state: "",
            phone: "",
            email: "",
          });
          return;
        }
      }
      if (formData.veterinarianName !== "") {
        if (!validateName(formData.veterinarianName)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "",
            zipCode: "",
            vetName: "Veterinarian Name should be text",
            address: "",
            state: "",
            phone: "",
            email: "",
          });
          return;
        }
      }
      if (formData.state !== "") {
        if (!validateCity(formData.state)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "",
            zipCode: "",
            vetName: "",
            address: "",
            state: "Invalid State",
            phone: "",
            email: "",
          });
          return;
        }
      }
      if (formData.zipCode !== "") {
        if (!validateZipCode(formData.zipCode)) {
          setMessages({
            ...errMessages,
            hospitalName: "",
            emptyMessage: "",
            city: "",
            zipCode: "Invalid Zip code",
            vetName: "",
            address: "",
            state: "",
            phone: "",
            email: "",
          });
          return;
        }
      }

      if (params.path === "edit") {
        dispatch(updateSingleteam(formData));
      } else {
        const { _id, ...filteredFormData } = formData;
        dispatch(addNewteam(filteredFormData));
      }
    } else {
      setMessages({ ...errMessages, emptyMessage: "Email should not empty" });
    }
  };
  useEffect(() => {
    dispatch(errorClean());
    dispatch(messageClean());
    stateData();
  }, []);
  useEffect(() => {
    try {
      if (params.path === "edit") {
        dispatch(getSingleteam(teamId));
      }
    } catch (error) {
      console.log(error);
    }
  }, [params.teamId]);

  useEffect(() => {
    dispatch(errorClean());
    dispatch(messageClean());

    if (teamMessage !== "") {
      setMessages({ ...errMessages, emptyMessage: "" });

      dispatch(errorClean());
      dispatch(messageClean());
      if (location.pathname === "/user/care-team/add-care-team/add/activate") {
        navigate(`/user/activate/code`, { state: location.state });
      } else {
        navigate(`/user/care-team`);
      }
    }
  }, [teamMessage]);

  useEffect(() => {
    cityData(stateCode);
  }, [stateCode]);

  const toggleFullText = () => {
    setShowFullText((prev) => !prev);
  };

  const text =
    "Although providing your veterinarian's information is optional, we strongly encourage it. Upholding the veterinary-client-patient relationship (VCPR) is important to us, and we advise sharing your pet's test results with one or more veterinarians for expert medical insights and guidance, regardless of whether the results are positive or negative. If you have a preferred veterinarian, we will automatically share the results with them to ensure these findings are incorporated into your pets medical records. In the event of a positive test result, your veterinarian can also help with treatment and care. If you don't have a veterinarian, feel free to consult with our in-house expert or allow us to connect you with our virtual veterinarian partners.";

  const truncatedText = showFullText ? text : text.slice(0, text.length / 5);

  return (
    <div className="tw-relative tw-top-[-9.375rem] tw-px-3 md:tw-px-5 lg:tw-px-10 tw-flex tw-flex-col tw-gap-10">
      <div className="tw-px-6 sm:tw-px-8 md:tw-px-8 lg:tw-px-10 tw-py-2 tw-flex tw-flex-col gap-3 tw-w-full tw-bg-[#FFFFFF] tw-rounded-2xl tw-shadow-3xl">
        <div>
          <span className="tw-font-bold tw-text-[24px]  md:tw-text-[26px] lg:tw-text-[32px]">
            Contact Details
          </span>
        </div>
        <div className="tw-flex tw-gap-5 tw-text-[20px]">
          <span className="tw-text-[16px] tw-font-light">
            {truncatedText}
            {!showFullText && (
              <p
                className="tw-text-reddishOrange tw-cursor-pointer"
                onClick={toggleFullText}
              >
                Learn More
              </p>
            )}
            {showFullText && (
              <p
                className="tw-text-reddishOrange tw-cursor-pointer"
                onClick={toggleFullText}
              >
                Fold Back
              </p>
            )}
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-4 tw-text-[16px] lg:tw-text-[20px]">
          {data.map((d, i) =>
            !(d.label === "City") ? (
              <div
                className="tw-flex tw-flex-col tw-flex-1 tw-items-start"
                key={i}
              >
                <label className="tw-font-semibold">{d.label}</label>
                <input
                  type={d.type}
                  name={d.name}
                  className="tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full md:tw-w-10/12 lg:tw-w-1/2 tw-placeholder-gray-400 tw-font-light"
                  placeholder={d.placeholder}
                  onChange={onChange}
                  value={`${
                    (formData as any)[d?.name] ? (formData as any)[d?.name] : ""
                  }`}
                />
                <span className=" tw-text-xs tw-text-red-500">
                  {d.name === "hospitalName"
                    ? errMessages.hospitalName
                    : d.name === "veterinarianName"
                    ? errMessages.vetName
                    : d.name === "address"
                    ? errMessages.address
                    : d.name === "email"
                    ? errMessages.email
                    : d.name === "zipCode"
                    ? errMessages.zipCode
                    : errMessages.phone}
                </span>
              </div>
            ) : (
              <div
                className="tw-flex tw-flex-col lg:tw-flex-row tw-w-full md:tw-w-10/12 lg:tw-w-1/2 tw-gap-6"
                key={i}
              >
                <div className="tw-flex tw-flex-col tw-items-start tw-flex-1">
                  <label className="tw-font-semibold">State</label>
                  <select
                    className="tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full tw-placeholder-gray-400 tw-font-light"
                    name="state"
                    onChange={(e) => {
                      setStateCode(e.target.value);
                      stateChangeHandler(
                        e.target.children[e.target.selectedIndex].innerHTML
                      );
                    }}
                  >
                    <option value="">Select State</option>
                    {states.map((option: any, index: any) => {
                      return (
                        <option key={index} value={option.code}>
                          {option.name}
                        </option>
                      );
                    })}
                  </select>
                  <span className=" tw-text-xs tw-text-red-500">
                    {errMessages.state !== "" ? errMessages.state : ""}
                  </span>
                </div>

                <div className="tw-flex tw-flex-col tw-items-start tw-flex-1">
                  <label className="tw-font-semibold">City</label>
                  <select
                    className="tw-border tw-border-gray-400 tw-text-black tw-rounded-lg tw-text-sm tw-p-4 tw-my-2 tw-w-full tw-placeholder-gray-400 tw-font-light"
                    name="city"
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={`${
                      (formData as any)["city"] ? (formData as any)["city"] : ""
                    }`}
                  >
                    <option value="">Select City</option>
                    {cities.map((option: any, index: any) => {
                      return (
                        <option key={index} value={option.name}>
                          {option.name}
                        </option>
                      );
                    })}
                  </select>
                  <span className=" tw-text-xs tw-text-red-500">
                    {errMessages.city !== "" ? errMessages.city : ""}
                  </span>
                </div>
              </div>
            )
          )}
        </div>
        {/* <div className="tw-flex tw-items-center">
          <FormControlLabel
            label="If you don't have access to local veterinary services or have an established relationship with a local vet, would you be interested in getting connected with a telemedicine veterinary service?"
            className="tw-w-full sm:tw-w-9/12 lg:tw-w-2/3 tw-gap-2"
            control={
              <Checkbox
                sx={{
                  marginLeft: "0",
                  "& .MuiSvgIcon-root": {
                    fontSize: "26px", // Change to your desired size
                  },
                  "&.Mui-checked": {
                    color: "#FF503D", // Change to your desired color when checked
                  },
                }}
                onChange={handleCheckbox}
              />
            }
          />
        </div> */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          <span className=" tw-text-xs tw-text-red-500">
            {errMessages.emptyMessage}
          </span>
          <span className=" tw-text-xs tw-text-red-500">
            {errorMessage.message ? errorMessage.message : ""}
          </span>
          <div className="tw-flex tw-gap-8 tw-text-[16px] sm:tw-text-[20px] tw-mb-8 tw-mt-6 tw-place-items-center">
            <button
              disabled={loading}
              className="tw-flex tw-items-center tw-p-1 sm:tw-p-3 tw-gap-2 tw-justify-center tw-w-[100px] sm:tw-w-[116px] tw-h-[42px] sm:tw-h-[48px] tw-left-[160px] tw-top-[783.48px] tw-bg-[#FF503D] tw-rounded-xl tw-text-white"
              onClick={() => {
                handleAddClick();
              }}
            >
              {params.path === "edit"
                ? loading
                  ? "Editing.."
                  : "Edit"
                : loading
                ? "Saving.."
                : "Save"}
            </button>
            <button
              className="tw-flex tw-border tw-border-black tw-p-1 sm:tw-p-3 tw-justify-center tw-items-center tw-w-[100px] sm:tw-w-[116px] tw-h-[42px] sm:tw-h-[48px] tw-rounded-xl"
              onClick={() => {
                navigate(`/user/care-team`);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
